module.exports = __webpack_public_path__ + "static/img/gouwuka.1d08432.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newVcard/gouwuka.png
// module id = 7oDp
// module chunks = 1